/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Admin_Commission_Quarter_Mark_PaidInputs */



/**
* | output |
* | --- |
* | "Mark quarter paid ({amount})" |
*
* @param {Partner_Admin_Commission_Quarter_Mark_PaidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_quarter_mark_paid = /** @type {((inputs: Partner_Admin_Commission_Quarter_Mark_PaidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Quarter_Mark_PaidInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Quartal als ausgezahlt markieren (${i?.amount})`)
	return /** @type {LocalizedString} */ (`Mark quarter paid (${i?.amount})`)
});